import React from "react";
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import { getFormattedTime, isEventLiveBySchedule, getWeekdayLabel } from "./utils/shared/time";
import { EVENT_STATUS } from "./constants/event";
import nowPlayingSvg from "../assets/nowPlaying.svg";
import hasPregame from "../assets/hasPregame.svg";
import "./epg.scss";
import { useEvents } from './context/EventsContext';

const renderParsedTime = (event) => {
    const mainStartTime = (event.information && event.information.main_start_time) || event.schedule_start;

    return (
        <>
            <p className="eventCardTime">
                Pregame&nbsp;
                {getFormattedTime(event.schedule_start)}
                {" | "}Event start&nbsp;
                {getFormattedTime(mainStartTime)}
            </p>
        </>
    );
};

const renderEventStatus = (event, eventStatus) => {
    const { isNowPlaying, isScheduledFlag, liveButtonText } = eventStatus;

    return (
        <div className={"liveContainer"}>
            <div
                className={`
          ${"liveButton"}
          ${event.status === EVENT_STATUS.LIVE || event.status === EVENT_STATUS.COMING ? "live" : ""}
          ${isNowPlaying ? "nowPlaying" : ""}
          ${isScheduledFlag ? "scheduled" : ""}
        `}
            >
                {isNowPlaying && <img src={nowPlayingSvg} alt="Now playing" />}
                {isNowPlaying ? EVENT_STATUS.NOW_PLAYING : liveButtonText}
            </div>
            {event.schedule_start && (
                <div className="hasPregame">
                    <img src={hasPregame} alt="Has pregame" />
                </div>
            )}
        </div>
    );
};

const EventCardEPG = ({ event, onFocus, onEnterPress, index, rowId }) => {
    const { thumbnail: img, title, id } = event;
    const focusKey = `event-${rowId}-${index}`;
    const { activeLiveContent } = useEvents();

    const { ref, focused } = useFocusable({
        focusKey,
        onEnterPress,
        onFocus: (focusProps) => {
            onFocus({
                ...focusProps,
                index,
            });
        },
        extraProps: {
            event,
            focusKey,
        },
    });

    // Calc. event status to use it for labels
    const eventStatus = React.useMemo(() => {
        const isNowPlaying = (event.status === EVENT_STATUS.LIVE || event.status === EVENT_STATUS.COMING) && activeLiveContent && activeLiveContent.contentType === 'live_event' && activeLiveContent.id === event.id;
        const isLiveByClock = isEventLiveBySchedule(event.schedule_start, event.schedule_end);
        const isLive = isNowPlaying || isLiveByClock || event.status === EVENT_STATUS.COMING;
        const isScheduledFlag = !isLive && (event.status === EVENT_STATUS.SCHEDULED || event.status === EVENT_STATUS.COMING);
        let weekdayLabel = null;
        if (isScheduledFlag && event.schedule_start) {
            weekdayLabel = getWeekdayLabel(event.schedule_start);
        }

        const liveButtonText = isLive ? EVENT_STATUS.LIVE : <span>{weekdayLabel ?? event.status}</span>;

        return {
            isNowPlaying,
            isLive,
            isScheduledFlag,
            liveButtonText,
        };
    }, [event.isDeviceSubscribed, event.schedule_start, event.schedule_end, event.status, activeLiveContent]);

    return (
        <div ref={ref} className="eventCard">
            <div className="imageContainer">
                <img
                    src={`${event.thumbnail}${event.thumbnail.includes('?') ? '&' : '?'}width=387&height=200`}
                    loading="lazy"
                    decoding="async"
                    className={`${"eventCardImg"} ${focused ? "focusedItem" : ""}`}
                    alt={event.title}
                />
                {renderEventStatus(event, eventStatus)}
            </div>
            {renderParsedTime(event)}
            <p className="eventCardTitle">{title}</p>
            <p className="eventCardLabel">{event.label}</p>
        </div>
    );
};

export default EventCardEPG;
